import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgClockMostOfTheTimeGlyphSecondary from './svgs/ClockMostOfTheTimeGlyphSecondary.js';
import SvgClockMostOfTheTimeGlyph from './svgs/ClockMostOfTheTimeGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var clockMostOfTheTimeGlyph = (props => useIcon(SvgClockMostOfTheTimeGlyph, SvgClockMostOfTheTimeGlyphSecondary, props));

export { clockMostOfTheTimeGlyph as default };
